import { MegaphoneIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { useEffect, useState } from "react";

export default function FixedBanner({ router }) {
  const [dismiss, setDismissed] = useState<string | boolean>(true);

  useEffect(() => {
    const value = localStorage.getItem("cc.offer.banner7");
    setDismissed(!!value);

    // setTimeout(() => {
    //   setDismissed(true)
    // }, 60 * 1000)
  }, []);

  if (dismiss || router.pathname.includes("booking")) {
    return null;
  }

  const close = () => {
    localStorage.setItem("cc.offer.banner7", "y");
    setDismissed(true);
  };

  return (
    <div className="bg-brand-600">
      <div className="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex w-0 flex-1 items-center">
            <span className="flex rounded-lg bg-brand-500 p-2">
              <MegaphoneIcon
                className="h-6 w-6 text-white"
                aria-hidden="true"
              />
            </span>
            <p className="ml-3 font-medium text-white">
              <span className="md:hidden">
                Up to 50% off courses in June, July & August • Use code:
                SUMMER2025{" "}
              </span>
              <span className="hidden md:inline">
                Up to 50% off courses in June, July & August • Use code:
                SUMMER2025{" "}
              </span>
            </p>
          </div>
          <div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
            <Link
              href="https://cosmetic.college/courses/"
              className="w-full md:w-auto flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-brand-600 shadow-sm hover:bg-brand-50"
            >
              Book now
            </Link>
          </div>
          <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
            <button
              type="button"
              onClick={close}
              className="-mr-1 flex rounded-md p-2 hover:bg-brand-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
